import Vue from 'vue'
import { PatientState, PatientFilter, PatientRecord, PatientLogEntry } from './types'

const getDefaultState = () => {
    const state: PatientState = {
        phoneStatus: []
    }
    return state;
}

export default {
    namespaced: true,
    state: getDefaultState(),
    mutations: {
        SET_PHONE_STATUS(state: PatientState, status: Array<any>) {
            state.phoneStatus = status;
        },
        RESET_STATE(state: PatientState) {
            Object.assign(state, getDefaultState())
        }
    },
    actions: {
        async getList({ rootState }, filter: PatientFilter) {
            // SET FORM DATA
            const params = new FormData();
            const entityId: number = rootState.auth.entityId;
            if (entityId != 0) {
                params.append('entityId', String(entityId));
            }
            params.append('firstName', filter.firstName);
            params.append('lastName', filter.lastName);
            params.append('insurerId', filter.insurerId);
            params.append('insurerMemberId', filter.insurerMemberId);
            params.append('EMR_ID', filter.EMR_ID);
            params.append('withPhoneErrors', filter.withPhoneErrors ? String(filter.withPhoneErrors) : "");
            params.append('pageNumber', String(filter.pageNumber));
            params.append('rowsPerPage', String(filter.rowsPerPage));
            // GET PATIENTS ASYNC
            const { data } = await Vue.axios.post('patient/list', params)
            //
            return data;
        },
        async getPatient({ commit }, id: number) {
            // SET FORM DATA
            const params = new FormData();
            params.append('id', String(id));
            // GET PATIENT ASYNC
            const { data } = await Vue.axios.post('patient/list/item', params)
            //
            return data;
        },
        async getLogById({ commit }, id: number) {
            // SET FORM DATA
            const params = new FormData();
            params.append('id', String(id));
            // SET GAP LOG ASYNC
            const { data } = await Vue.axios.post('patient/log', params);
            //
            return data;
        },
        async getPhoneStatus({ commit, state }) {
            if (state.phoneStatus.length) return;
            // GET PHONE STATUS LIST ASYNC
            const { data } = await Vue.axios.post('patient/phonestatus/list');
            //
            commit("SET_PHONE_STATUS", data);
        },
        async saveLog({ commit }, entry: PatientLogEntry) {
            // SET FORM DATA
            const params = new FormData();
            params.append('patientId', String(entry.patientId));
            params.append('typeId', entry.typeId);
            params.append('comment', entry.comment ? entry.comment : "");
            // SAVE GAP LOG ASYNC
            const { data } = await Vue.axios.post('patient/log/save', params);
            //
            return data;
        },
        async saveSystemLog({ commit }, entry: PatientLogEntry) {
            // SET FORM DATA
            const params = new FormData();
            params.append('patientId', String(entry.patientId));
            params.append('typeId', entry.typeId);
            params.append('comment', entry.comment ? entry.comment : "");
            // SAVE GAP LOG ASYNC
            const { data } = await Vue.axios.post('patient/log/save/system', params);
            //
            return data;
        },
        async save({ rootState }, patient: PatientRecord) {
            const params = new FormData();
            // SET FORM DATA
            const entityId: number = rootState.auth.entityId;
            if (patient.id) {
                params.append('id', String(patient.id));
            }
            params.append('entityId', String(entityId));
            params.append('firstName', patient.firstName);
            params.append('lastName', patient.lastName);
            params.append('lastName2', patient.lastName2 ? patient.lastName2 : "");
            params.append('birthdate', patient.birth.date);
            params.append('gender', patient.gender);
            params.append('countryId', patient.countryId);
            params.append('insurerId', patient.insurerId);
            params.append('insurerMemberId', patient.insurerMemberId);
            params.append('contactName', patient.contactName);
            // PHONES
            params.append('mobilePhone', patient.phone.mobile ? patient.phone.mobile : "");
            params.append('mobilePhoneStatusId', patient.phone.mobile ? patient.phone.mobileStatusId : "NP");
            params.append('homePhone', patient.phone.home ? patient.phone.home : "");
            params.append('homePhoneStatusId', patient.phone.home ? patient.phone.homeStatusId : "NP");
            params.append('otherPhone', patient.phone.other ? patient.phone.other : "");
            params.append('otherPhoneStatusId', patient.phone.other ? patient.phone.otherStatusId : "NP");
            params.append('otherPhone2', patient.phone.other2 ? patient.phone.other2 : "");
            params.append('otherPhone2StatusId', patient.phone.other2 ? patient.phone.other2StatusId : "NP");
            //
            params.append('email', patient.email ? patient.email : "");
            params.append('lang', patient.lang);
            params.append('EMR_ID', patient.EMR_ID ? patient.EMR_ID : "");
            // SAVE PATIENT ASYNC
            const { data } = await Vue.axios.post('patient/save', params);
            //
            return data;
        }
    }
}
